import React from 'react';
import { SpinnerIcon } from './styles';

interface SpinnerProps {
  size?: number;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 30 }: { size?: number }) => {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SpinnerIcon size={size} />
    </div>
  );
};

export default Spinner;
